import { Injectable } from '@angular/core';

// @Injectable()
@Injectable({ providedIn: 'root' })

export class TableDataService {
  getTableData() {
    return {
      result: [
        {
          online: true,
          profileImageUrl: '/assets/Icons/user-avatar.svg',
          title: 'Bad grades and solutions',
          description: 'Hi everyone, We are going to talk about a noticeable topic that is grades and discuss in a ways that we can be improve it since...',
          tag: 'Grades', //بحرانی
          date: '2024-05-12T11:42:34Z',
        },
        {
          online: true,
          profileImageUrl: '/assets/Icons/user-avatar.svg',
          title: 'Bad grades and solutions',
          description: 'Hi everyone, We are going to talk about a noticeable topic that is grades and discuss in a ways that we can be improve it since...',
          tag: 'Grades', //بحرانی
          date: '2024-05-12T11:42:34Z',
        },
        {
          online: true,
          profileImageUrl: '/assets/Icons/user-avatar.svg',
          title: 'Bad grades and solutions',
          description: 'Hi everyone, We are going to talk about a noticeable topic that is grades and discuss in a ways that we can be improve it since...',
          tag: 'Grades', //بحرانی
          date: '2024-05-12T11:42:34Z',
        },
      ]
    }
  }

  getTable() {
    return Promise.resolve(this.getTableData());
  }

};